import React from "react";
import { Button, Dropdown, Modal, Input } from "antd";
import {
  MailOutlined,
  ShareAltOutlined,
  WhatsAppOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import { selectAuthInfo } from "../../pages/Auth/authSelectors";

const ShareDocumentButton = ({
  disabled,
  screens,
  shareOpen,
  setShareOpen,
  email,
  setEmail,
  loading,
  onEmail,
  onWhatsApp,
  modalTitle = "Send Document Email",
}) => {

  const authInfo = useSelector(selectAuthInfo);  
  const isProSubscription = authInfo?.subscription?.split("_")?.some(part => part.toLowerCase() === "pro");

  if (!isProSubscription) return null;

  return (
    <>
      <Dropdown
        disabled={disabled || loading}
        menu={{
          items: [
            {
              key: "email",
              icon: <MailOutlined />,
              label: "Email",
              onClick: () => setShareOpen(true),
            },
            {
              key: "wa",
              icon: <WhatsAppOutlined />,
              label: "WhatsApp",
              disabled: loading,
              onClick: onWhatsApp,
            },
          ],
        }}
      >
        <Button type="primary" icon={<ShareAltOutlined />} loading={loading} disabled={disabled || loading}>
          {!screens?.xs && "Share"}
        </Button>
      </Dropdown>

      <Modal
        title={modalTitle}
        open={shareOpen}
        onCancel={() => setShareOpen(false)}
        onOk={onEmail}
        confirmLoading={loading}
      >
        <Input
          placeholder="Customer/Supplier Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </Modal>
    </>
  );
};

export default ShareDocumentButton;
